import { useMemo } from 'react'

import {
  useLocalVideo,
  useLogger,
  useMeetingManager,
} from 'amazon-chime-sdk-component-library-react'
import {
  BackgroundReplacementVideoFrameProcessor,
  DefaultVideoTransformDevice,
  Device,
  LogLevel,
} from 'amazon-chime-sdk-js'

async function getBackgroundProcessor() {
  const image = await fetch('/call-background.jpg')
  const imageBlob = await image.blob()
  const options = { imageBlob }
  return await BackgroundReplacementVideoFrameProcessor.create(
    undefined,
    options
  )
}

export function useMeetingBackground() {
  const { isVideoEnabled } = useLocalVideo()

  const meetingManager = useMeetingManager()
  const logger = useLogger()
  logger.setLogLevel(LogLevel.ERROR)
  const selectedVideoInputDevice = meetingManager.selectedVideoInputDevice

  useMemo(() => {
    async function setBackground() {
      if (!(await BackgroundReplacementVideoFrameProcessor.isSupported())) {
        return
      }
      if (!selectedVideoInputDevice || !isVideoEnabled) {
        return
      }

      const backgroundProcessor = await getBackgroundProcessor()
      if (!backgroundProcessor) {
        return
      }

      const transformDevice = new DefaultVideoTransformDevice(
        logger,
        selectedVideoInputDevice as Device,
        [backgroundProcessor]
      )
      meetingManager.meetingSession?.audioVideo.startVideoInput(transformDevice)
    }

    setBackground()
  }, [meetingManager, logger, isVideoEnabled, selectedVideoInputDevice])
}
